module.exports = __webpack_public_path__ + "static/media/upythonWithMicro.c1c683cf.png";